import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Logs'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Logs',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/logs',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
